import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { resetPasswordRequest, authFailure } from '../../redux/auth/actions';
import ErrorMessage from './error';
import Spinner from './spinner';
import InfoMessage from './info';
import { useNavigate } from 'react-router-dom';
import Layout from '../layout';
import { useTranslation } from 'react-i18next';

const ResetPassword = () => {
    const { t } = useTranslation();
    const [newpassword, setNewPassword] = useState("");
    const [email, setEmail] = useState("");
    const [token, setToken] = useState("");
    const search = useLocation().search;
    const dispatch = useDispatch();
    const navigate = useNavigate();


    useEffect(() => {
        var pEmail = new URLSearchParams(search).get('to');
        pEmail = decodeURIComponent(pEmail);
        const pToken = new URLSearchParams(search).get('code')

        if (pEmail && pToken) {
            setEmail(pEmail);
            setToken(pToken);
        }
    }, [search])

    const resetPassword = (e) => {
        e.preventDefault();
        if (newpassword === "") {
            dispatch(authFailure(t('password-empty-error')));
            return;
        }
        dispatch(resetPasswordRequest({ password: newpassword, token: token, navigate: navigate }));
    }

    return (
        <Layout selected="reset">
            <div className="mb-3 col-md-4 offset-md-4 text-center mt-5">
                <InfoMessage />
                <ErrorMessage />
                <Spinner />
                <p className="lead">{t('reset-password-for')} <b>{email}</b></p>
                <form onSubmit={resetPassword}>
                    <fieldset>
                        <div className="form-group my-3">
                            <input type="password" className="form-control" placeholder={t('enter-new-password')}
                                value={newpassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                aria-label={t('enter-new-password-aria')} />
                        </div>
                    </fieldset>
                    <button type="submit" className="btn btn-outline-dark">{t('reset-password')}</button>
                </form>
                <div className="my-3">
                    <Link to="/signin">{t('signin')}</Link> &nbsp; | &nbsp;
                    <Link to="/signup">{t('signup')}</Link>
                </div>
            </div>
        </Layout>

    )
}
export default ResetPassword
